
    var riot = require('riot')
    //src: starling/src/tags/undo-redo.html
riot.tag2('undo-redo',
  '<div data-tip="{undoTip()}"> <button class="Button Button--Plain Button--Icon" disabled="{!undoAvailable()}" onclick="{undoClick}"> <svg class="Button__Icon"> <use xlink:href="#undo-icon"></use> </svg> </button> </div> <div data-tip="{redoTip()}"> <button class="Button Button--Plain Button--Icon" disabled="{!redoAvailable()}" onclick="{redoClick}"> <svg class="Button__Icon"> <use xlink:href="#redo-icon"></use> </svg> </button> </div>',
  '',
  'class="flex hideWhenPresenting"', function(opts) {
'use strict';

var _this = this;

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _opts = opts,
    canvas = _opts.canvas;
var isMac = canvas.isMac;

canvas.undoRedoTag = this;

this.undoClick = function () {
  if (canvas.isViewOnly()) return;
  _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return canvas.operation.undo();

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
  canvas.closeUndoBanner();
  _this.update();
  _eventTracking2.default.track({
    category: 'Undo-Redo',
    action: 'Undo',
    label: 'App-Header-Undo'
  });
};

this.redoClick = function () {
  if (canvas.isViewOnly()) return;
  _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return canvas.operation.redo();

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }))();
  canvas.closeUndoBanner();
  _this.update();
  _eventTracking2.default.track({
    category: 'Undo-Redo',
    action: 'Redo',
    label: 'App-Header-Redo'
  });
};

this.undoAvailable = function () {
  return canvas.operation.ur.undoStack.length > 0;
};

this.redoAvailable = function () {
  return canvas.operation.ur.redoStack.length > 0;
};

this.undoTip = function () {
  return _this.undoAvailable() ? 'Undo (' + (isMac ? '⌘Z' : 'Ctrl+Z') + ')' : 'Nothing to undo';
};

this.redoTip = function () {
  return _this.redoAvailable() ? 'Redo (' + (isMac ? '⌘Y' : 'Ctrl+Y') + ')' : 'Nothing to redo';
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('undo-redo')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/undo-redo.html
// module id = 754
// module chunks = 0